const imports = {
  mappingFields: 'Zuordnungsfelder',
  fieldsInDB: 'Felder in der Datenbank',
  csvFields: 'CSV-Feld',
  selectTheField: 'Wählen Sie das Feld aus',
  csvFile: 'CSV-Datei',
  typeOfImport: 'Art des Imports',
  selectTypeOfReports: 'Wählen Sie den Berichtstyp aus',
  default: 'Standardwert',
  uploadedSuccessfuly: 'Erfolgreich hochgeladen!',
  downloadExample: 'Beispiel herunterladen',
  noCollection: 'Keine Sammlung mit diesem Namen',
  uploadMessage: 'This might take up to 1 second per item.,ANFRAGE - {{num}} Elemente. Dies kann bis zu eine Sekunde pro Element dauern., This might take up to 1 second per item.',
};

export default imports;
